<template>
  <div class="ecommercedefenseproduct-cpmponents">
    <div class="page-product-chart-box">
      <div class="page-header">
          <h2>{{ $t("DashboardProduct.paneltitle1") }}
            <el-button v-if="showcharts" size="mini" @click="hiddencharts()">{{$t("charts.hide")}} <i class="el-icon-arrow-up el-icon--right"></i></el-button>
            <el-button v-if="!showcharts" size="mini" @click="hiddencharts()">{{$t("charts.show")}} <i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <span style="float:right; font-size:14px;">{{$t("charts.latestupdate")}}：{{latestupdatetime}}</span>
          </h2>
      </div>
      <div v-if="showcharts">
        <div class="dashboard-row">
          <div class="dashboard-col-200">
            <div class="dashboard-container dashboard-height-400">
              <NumberCard 
                :firsttitle="$t('Infringements.t1')"
                :firstnumber="numcharts.FakeProductCountformat"
                :firstunit="$t('jgjk.s73')"
                :secondtitle="$t('jgjk.s2')"
                :secondnumber="numcharts.FakeProductRate"
                :secondunit="$t('DashboardProduct.secondunit')"
                :subid="showsubid"
                :nodata="false"
                routename="EcommerceDefenseShowLinks"
              />
            </div>
          </div>
          <div class="dashboard-col-auto">
            <el-row>
              <el-col :span="12" style="padding-right:10px;">
                <div class="dashboard-container">
                  <PieChart
                    chartheight="301px"
                    legendtype="vertical"
                    chartid="piechartdataid"
                    :charttitle="$t('Infringements.t3')"
                    :chartdata="piechartdata1"
                  />
                </div>
              </el-col>
              <el-col :span="12" style="padding-left:10px;">
                <div class="dashboard-container">
                  <PieChart
                    chartheight="301px"
                    legendtype="vertical"
                    chartid="piechartdataid1"
                    :charttitle="$t('Infringements.t4')"
                    :chartdata="piechartdata2"
                  />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="dashboard-row">
          <div class="dashboard-col-full">
            <div class="dashboard-container">
              <LineChart
                :charttitle="$t('Infringements.t5')" 
                :chartdata="linechartdata"
                :animation="true"
                chartid="line1"
              />
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="page-product-table-box">
      <div class="page-header">
          <h2>{{$t('dsfx.t13')}}</h2>
      </div>
      <div class="searchwrap">
        <el-form :inline="true" class="table-form-inline search-left">
          <el-form-item :label="$t('jgjk.s13')">
            <el-select v-model="filterselector[0].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters0change">
              <el-option
                v-for="item in filterselector[0].options"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jgjk.s14')">
            <el-select v-model="filterselector[1].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters1change">
              <el-option
                v-for="item in filterselector[1].options"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div class="pricetablesearchline">
          <el-input 
            style="width:250px" 
            v-model="searchNeedle" 
            :placeholder="$t('jgjk.s641')" 
            size="mini" 
            @keyup.enter.native="onTableListSaerch()"
          ></el-input>
          <el-button type="danger" @click="onTableListSaerch()" size="mini">{{ $t('dsfx.t26') }}</el-button>
          <el-button type="danger" plain @click="downloaddata()" :loading="downloading" size="mini">{{ $t('jgjk.s74') }}</el-button>
        </div>
      </div>
    </div>
    
    <div class="tablebox">
      <el-table 
        :cell-style="this.getTableCellStyle" 
        size="mini" 
        v-loading="tableloading" 
        ref="multipleTable" 
        :data="tableData" 
        tooltip-effect="dark" 
        style="width: 100%"
        @sort-change="sortthiscolumn"
      >
        <el-table-column prop='skuid' label="SKUID" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop='series' :label="$t('jgjk.s13')" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop='name' :label="$t('jgjk.s15')" show-overflow-tooltip></el-table-column>
        <el-table-column prop='type' :label="$t('jgjk.s16')" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop='model' :label="$t('jgjk.s14')" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop='updateAt' :label="$t('jgjk.s17')" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='FakeProductRate' :label="$t('Infringements.t6')" width="170" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='LinkCount' :label="$t('jgjk.s6')" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('jgjk.s19')" width="90">
          <template slot-scope="scope">
            <button class="viewactivebrand" type="button" 
              @click="viewUrl(scope.row.skuid,
              scope.row.series,  
              scope.row.model,
              scope.row.type,
              scope.row.name,
              scope.row.project,
              scope.row.price)"
            ></button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagewrap">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="pagesize"
        layout="total, prev, pager, next, sizes"
        :total="pagingtotal">
      </el-pagination>      
    </div>

  </div>
</template>

<script>
import NumberCard from '../Charts/NumberCard.vue'
import PieChart from '../Charts/ChartPie.vue'
import LineChart from '../Charts/LineChart.vue'
export default {
  components:{
    NumberCard,
    PieChart,
    LineChart
  },
  data(){
    return{
      downloading: false,
      numcharts: {
        FakeProductCount: 0,
        FakeProductRate: '00.00%'
      },
      showcharts: true,
      latestupdatetime: '',
      subid: this.$route.params.Id,
      piechartdata1: {},
      piechartdata2: {},
      linechartdata: {},
      filterselector: [{
          fieldid: "Series",
          source: "series",
          options: [],
          default: ''
      },{
          fieldid: "Model",
          source: "model",
          options: [],
          default: ''
      }],
      searchNeedle: '',
      pagesize: 25,
      page: 1,
      tableloading: false,
      tableData: [],
      pagingtotal: 0,
      currentPage: 1,
      tableorder: '11',
      showsubid: false
    }
  },

  mounted(){
    let that = this
    let ifshowcharts = JSON.parse(localStorage.getItem("showcharts"))
    if(ifshowcharts === null){
      that.getDashboard()
      that.showcharts = true
    }else{
      that.getDashboard()
      that.showcharts = false
    }
    that.getFilter()
    that.getTableList()
  },

  methods: {

    /**
     * 隐藏图表
     */
    hiddencharts: function(){
      let that = this
      let types = that.showcharts
      if(types === true){
        that.showcharts = false
        that.setLocalStorage( "showcharts", false )
      }else{
        localStorage.removeItem("showcharts")
        // that.getDashboard()
        that.showcharts = true
      }
    },

    /**
     * filters1change
     */
    filters0change: function(val){
      this.filterselector[0].default = val === '全部' ? '' : val
      this.getTableList()
    },

    /**
     * filters2change
     */
    filters1change: function(val){
      this.filterselector[1].default = val === '全部' ? '' : val
      this.getTableList()      
    },

    /**
     * onTableListSaerch
     */
    onTableListSaerch: function(){
      this.getTableList()
    },

    /**
     * handleSizeChange
     */
    handleSizeChange: function(val){
      this.currentPage = 1
      this.page = 1
      this.pagesize = val
      this.getTableList()
    },

    /**
     * handleCurrentChange
     */
    handleCurrentChange: function(val){
      this.page = val
      this.getTableList()
    },

    /**
     * Dashboard 接口
     */
    getDashboard: function(){
      let that = this 
      let requestQuery = {
        subid: that.subid
      }
      $.ajax({
        url:  that.API_URL + '/v3/commerce/merchandise/dashboard',
        type: "GET",
        data: requestQuery,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getDashboard',rex)
          if(rex.results[5].length === 0){
            that.$router.push({ name: 'DataPending', params: {Id: that.subid} })
          }
          that.numcharts.FakeProductCount = rex.results[0][0].FakeProductCount*1
          that.numcharts.FakeProductCountformat = that.millonFormat(rex.results[0][0].FakeProductCount*1)
          that.numcharts.FakeProductRate = rex.results[1][0].FakeProductRate
          that.latestupdatetime = that.$moment(rex.results[5][0].scoreTime).utc().format('MM-DD HH:mm')
          that.showsubid = rex.results[0][0].FakeProductCount*1 > 0 ? that.$route.params.Id : false

          // 疑似侵权商品渠道分布
          let piechannel = rex.results[3]
          let piechannelitem = []
          let legendDataitem = []
          for(let i=0; i<piechannel.length; i++){
            let _pie = {}
            _pie.value = piechannel[i].FakeProductCount
            _pie.name = that.setChannel(piechannel[i].ChannelName).loc
            _pie.itemStyle = {
              color: that.setChannel(piechannel[i].ChannelName).color
            }
            piechannelitem.push(_pie)
            legendDataitem.push(_pie.name)
          }
          that.piechartdata1 = {
            legendData: legendDataitem,
            seriesData: piechannelitem
          }
          
          // 商品侵权类型占比
          let pietype = rex.results[4]
          let newpietype = []
          for(let y=0; y<pietype.length; y++){
            if(pietype[y].FakeproductTypeCount/1 > 0){
              newpietype.push(pietype[y])
            }
          }
          let pietypeitem = []
          for(let i=0; i<newpietype.length; i++){
            let _pie = {}
            _pie.value = newpietype[i].FakeproductTypeCount
            _pie.name = that.setInfringementsType(newpietype[i].FakeproductType).txt
            _pie.itemStyle = {
              color: that.setInfringementsType(newpietype[i].FakeproductType).color
            }
            pietypeitem.push(_pie)
          }
          let ntype = newpietype.map(item => {
            return item.FakeproductType
          })

          let narr = []
          for(let x =0; x<ntype.length; x++){
            narr.push(that.setInfringementsType(ntype[x]).txt)
          }
          that.piechartdata2 = {
            legendData: narr,
            seriesData: pietypeitem
          }

          // 疑似侵权商品增量趋势变化
          let lineChartDataObj = rex.results[2]
          let x = [];
          let y = [];
          for (var i = 0; i < lineChartDataObj.length; i++) {
              x[i] = that.$moment(lineChartDataObj[i].FakeProductValueTradeData).format('YYYY-MM-DD')
              y[i] = lineChartDataObj[i].FakeProductValueTradeValue
          }
          that.linechartdata = {
            xAxis: x,
            yAxis: [{
              type: 'line',
              smooth: true,
              data: y
            }]
          }          

        },
        error: function(response) {
          if(response.status/1 === 500){
            that.$router.push({ name: 'DataPending', params: {Id: that.subid} })
          }
          if(response.status/1 === 401){
            that.$router.push({ name: 'Login'})
          }
        }
      })
    },

    /**
     * getFilter
     */
    getFilter: function(){
      let that = this;
      let url = that.API_URL + '/v3/commerce/merchandise/filter';
      let data = {
        subid: that.subid
      }
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getFilter', rex)

          let selectdefaultval = {
            name : that.$t('tabletabs.all'),
            value : ''
          }

          //series
          that.filterselector[0].options = rex.results[1].map(function(val){
            return {
              name: val.Series,
              value: val.Series
            }
          })
          that.filterselector[0].options.unshift(selectdefaultval)

          //Model
          /**
           * 去除型号中的空值
           */
          let modelarr = rex.results[2]
          for(let q = 0; q < modelarr.length; q++) {
            if(modelarr[q].Model == '') {
              modelarr.splice(q,1)
              q = q - 1
            }
          }
          that.filterselector[1].options = modelarr.map(function(val){
            return {
              name: val.Model,
              value: val.Model
            }
          })
          that.filterselector[1].options.unshift(selectdefaultval)

        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * getTableList
     */
    getTableList: function(){
      let that = this
      let url = that.API_URL + '/v3/commerce/merchandise/paging'
      let confs = {
        subid: that.subid,
        search: that.searchNeedle,
        page: that.page,
        size: that.pagesize,
        series: that.filterselector[0].default.replace(/'/, "\\'"),
        model: that.filterselector[1].default.replace(/'/, "\\'"),
        order: that.tableorder
      }
      that.tableloading = true
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
				data: confs,
        success: function(data){
          console.log('getTableList', data)
          that.pagingtotal = data.results[0][0].count
          let _list = data.results[1]
          _list.forEach(item => {
            item.name = item.productName
            item.updateAt = item.updateAt ? that.$moment(item.updateAt).utc().format('MM-DD HH:mm') : ''
            item.FakeProductRate = (item.FakeProductRate * 100).toFixed(2) + "%"
          })
          that.tableData = _list
          that.tableloading = false
          let EcommerceDefenseTaskId = {
            taskid: _list[0].project
          }
          that.setLocalStorage( "EcommerceDefenseTaskId", EcommerceDefenseTaskId )
        },
        error: function(err){
          console.log(err)
        }
      })
    },

    viewUrl: function(sid,series,model,type,name, pid, price){
      let EcommerceDefenseViewUrlPageData = {
        name: name,
        series: series,
        model: model,
        type: type,
        taskid: pid,
        price: price
      }
      this.setLocalStorage( "ecommercedefenseviewurl", EcommerceDefenseViewUrlPageData )
      this.$router.push({name: 'EcommerceDefenseProductUrl', params: {Id: this.subid, SkuId: sid}})
    },

    /**
     * 下载数据
     */
    downloaddata: function(){
      let that = this
      that.downloading = true
      let url = that.API_URL + '/v3/commerce/merchandise/getFakeInfo?'
                + 'project=' + that.subid
      // let setdate = new Date()
      // let filename = setdate.getTime()

      let nowtime = new Date()
      let objname = JSON.parse(localStorage.getItem("price")).val
      let filenametime = that.$moment(nowtime,'YYYY-MM-DDTHH:mm:ss.SSS').format('YYYYMMDDHHmm')
      let newname = ''
      for(let k=0; k<objname.length; k++){
        if(objname[k].subid/1 === that.$route.params.Id/1)
        newname = objname[k].name
      }
      let filename = newname ? newname : 'Download'
      let xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer '+JSON.parse(localStorage.getItem("token")).val+'')
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response;
          var reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = function (e) {
            var a = document.createElement('a')
            a.download = filename + '_Infringements_SKU_' + filenametime+'.xlsx'
            a.href = e.target.result
            $("body").append(a)
            a.click()
            $(a).remove()
            that.downloading = false
          }
        }
      }
      xhr.send()      
    },

    /**
     * 列表排序
     */
    sortthiscolumn: function(column){
      if(column.prop == "FakeProductRate" && column.order == "ascending"){
        this.tableorder = '00'
        this.getTableList()
      }else if(column.prop == "FakeProductRate" && column.order == "descending"){
        this.tableorder = '01'
        this.getTableList()
      }else if(column.prop == "FakeProductRate" && column.order == null){
        this.tableorder = ''
        this.getTableList()
      }else if(column.prop == "LinkCount" && column.order == "ascending"){
        this.tableorder = '10'
        this.getTableList()
      }else if(column.prop == "LinkCount" && column.order == "descending"){
        this.tableorder = '11'
        this.getTableList()
      }else if(column.prop == "LinkCount" && column.order == null){
        this.tableorder = ''
        this.getTableList()
      }else{
        return
      }
    },

  }
}
</script>